import * as React from 'react'
import { ErrorMessage } from './ErrorMessage'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ErrorMessageExamples = () => {
  return (
    <div className="ErrorMessageExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ErrorMessage />
      </Provider>
    </div>
  )
}
